import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import GenericHero from '../components/GenericHero';

const TeamPage = () => {
  const teamMembers = [
    {
      name: "Dave JK Kazoora",
      role: "Team Lead",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/Dave%20new_QNbvYChyp?updatedAt=1760262878845",
      bio: "Leads our team with vision and dedication to making homeownership accessible. 'From tenant to landlord. Daily, Nze landlord.' - Dave transforms lives through innovative daily payment solutions."
    },
    {
      name: "Titan Takuba",
      role: "Head of Creative",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/new%20titan_MhrC4TrD2?updatedAt=1760262801965",
      bio: "Creative visionary behind 'Your hustle, your home' messaging and innovative marketing strategies that resonate with hardworking Ugandans."
    },
    {
      name: "Rukundo Justus",
      role: "Head of Content",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/new%20rukundo_yvpdo4qaF?updatedAt=1760262673146",
      bio: "Crafts empowering content around 'Building your legacy, day by day' and educates our community about daily payment homeownership opportunities."
    },
    {
      name: "Apostle Grace Lubega",
      role: "Head Architect",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/Apostle%20Grace%20Lubega?updatedAt=1760199581199",
      bio: "Expert architect who designs homes for every Ugandan. Believes 'The path to ownership starts with a step' and creates functional designs for daily payment buyers."
    },
    {
      name: "Kenneth Owori",
      role: "Head IT",
      image: "https://customer-assets.emergentagent.com/job_quick-deploy-37/artifacts/2gx86brz_33333.jpeg",
      bio: "Technology leader enabling 'Daily payments. Your home.' through seamless digital experiences and efficient daily payment processing systems."
    },
    {
      name: "Sylvester Ajbaduta",
      role: "Operations Manager",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/new%20oga_P0RdHt26J?updatedAt=1760262482305",
      bio: "Ensures 'Buy daily. Own forever' becomes reality through smooth operations, quality control, and timely project delivery for all our clients."
    },
    {
      name: "Spensor Sabot",
      role: "Team Member",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/spencer?updatedAt=1760266058147",
      bio: "Dedicated team member contributing to NyiNimu's mission of making homeownership accessible through innovative daily payment solutions."
    },
    {
      name: "Pro Lawerance Muganga",
      role: "Board Chair",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/prof%20Lawerence%20muganga%20as%20the%20board%20chair?updatedAt=1760199335122",
      bio: "Board Chair providing strategic leadership and governance to ensure NyiNimu's continued growth and success in transforming homeownership in Uganda."
    },
    {
      name: "Agie Konde",
      role: "Engineer",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/Aggie%20konde%20As%20Eng?updatedAt=1760199401044",
      bio: "Skilled engineer ensuring quality construction and technical excellence in all NyiNimu projects, making daily payment homeownership a reality."
    },
    {
      name: "Joel Ritah Patricia",
      role: "Team Member",
      image: "https://ik.imagekit.io/hqhiltiie/Nyinimu/Team/Joel%20Rita%20Patricia?updatedAt=1760199499005",
      bio: "Valuable team member supporting NyiNimu's vision of 'Your hustle, your home' and helping hardworking Ugandans achieve their homeownership dreams."
    }
  ];

  return (
    <div className="relative">
      {/* Hero Section covers navbar */}
      <div className="absolute inset-0 h-[40vh] w-full -z-10">
        <img
          src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80"
          alt="Our Team"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
      </div>
      <div className="pt-0">
        <GenericHero
          title="Our Team"
          description="Meet the dedicated professionals working to make your homeownership dreams a reality."
          backgroundImage=""
        />
      </div>

      {/* Team Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-light title-font text-stone-800 mb-6">
              Meet Our Experts
            </h2>
            <p className="text-stone-600 text-lg max-w-3xl mx-auto">
              Our diverse team brings together expertise in real estate, finance, construction, and customer service to provide you with comprehensive support throughout your homeownership journey.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <Card key={index} className="group cursor-pointer border-0 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
                <div className="relative">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>

                <CardContent className="p-6 text-center">
                  <h3 className="text-xl font-medium title-font text-stone-800 mb-2">
                    {member.name}
                  </h3>
                  <p className="text-[#81be00] font-medium mb-4">
                    {member.role}
                  </p>
                  <p className="text-stone-600 leading-relaxed">
                    {member.bio}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TeamPage;